import { addEventListeners, removeEventListeners } from "../utils/dom";

export default class SalaryStatistics extends HTMLDivElement {

    connectedCallback() {

        addEventListeners(this.selectLists, "change", this.submitForm);
        
    }

    disconnectedCallback() {

        removeEventListeners(this.selectLists, "change", this.submitForm);

    }

    submitForm = (e) => {

        const hasValues = Array.from(this.selectLists).every(select => select.value !== null && select.value > 0);

        if (hasValues)
            this.querySelector("form").submit();

    }

    get selectLists() {
        return this.querySelectorAll("select");
    }
}

customElements.define('salary-statistics', SalaryStatistics, { extends: 'div' });